<template>
  <span>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button id="descargar" size="sm" class="ml-1" v-if="lst.length > 0"  :disabled="loader" variant="primary" @click="modalAlvertenciaDescagarTxt()" v-b-tooltip.hover title="Descargar Archivo">
      <span v-if="!loader"><b-icon icon="download"></b-icon></span>
      <span v-else>
                  <b-spinner small></b-spinner>
                  Descargando...
      </span>
    </b-button>
  </span>
</template>
<script>

import moment from "moment/moment";

export default {
  name: "ArrayToTxt",
  props: {
    lst: {type: Array},
    idsMultivaArchivoSFTP: {type: Array},
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.imagenModalBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABoCAYAAAAtkKSAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAdrSURBVHgB7Z1/bhNHFMffG68h/fGHETEQqVI3J6g5Qc0J4AZNTgD8UylBVRxVYNR/AidIOAH0BA0nIJyArdTW+QHC/0BDHM8wb+0kdrLJrtc7szOT+UiwNk4g5us3+9533swgOEinVQuhEoTAMBx7gYuoz7D7w6O9LXAMBAf453G9UWXirgBoMsCGvNbSvkeA2ORcvEWOr+Z+e78JlmOtkO9atdo3V4IF+Q7uImATpiOS0m5wOHwxt9SNwEKsFHL7yewDhriSJfImBRGe9UXvuW2CWiXk7h/1hjiEdflTN0AtEed8de7Rhw2wBGuEpChExDXQCEXnp/3e6nyr2wXDsULI3XZ9XQ6jC1AOEYfeHdOHWuOFLFnEI4wX02ghDRHxCKPFZGAoe+3ZFYNEJEKE6joYipFCdtrXFzhgCwxDDl/N3ad1rQlXVowbWjvtWsig+pd8GIKhcBByiDXLDTIvIkW1BQaLSDCBxkWlUULG0YjwC5iONCT+k3UtGIRRQsoh9SVYQgVwhfxeMARjhKQER15UW2/FgVD7bqa6AoZgRLJDn+xvr1bfgOH3xiR6HG6bML9pRER+fzW4DxaKSAQMjEh8So/IYbnxDizGhHKk/IgclBtWwwDXy058ShVy58n1e1aUG+mEM9Wg1HKk1KF1p12nITUERQgBr0HwQSKCrCHnF38GVQjofj7ozZc1dxlASWwPCuoQlIBypoIvzi2P37doBACsyOREhFA0shyRmTclPotQAqVEpGo/lUNlfm5pO0p6LW4X6cMbUERZiU8590iFfqr8ZG6cJyJx49e9LcHFn6AIlI4PlIB2IVX7qX3OX6d9jWD4ChRBU12dx7FLpRXtQg6HVIX/AEZQMgzZmu5yRKuQQz81BNeRiY/uckSbkPQJZcCMMZlVwxDv020ENKFNSJv91FzIqNTZ46NFSPpkmtiDo5o48WnPNkEDeiLSAT81L+TDggaUC0kJjiN+al5CHW0hyoW8TAnOeehoC1EqpFo/1SI0tIUoE5ISHJQpOHhi5EzMA5WJj7qItKA/VTcqfVglQlrTn6oZKkf+pak0BSgRUrmfajGBIh+2cCEvjZ+aHyVtIYUKOZgw9uVGGip82EKFDCCg+2IInouR5QgTQaH9sIUJeVn91Nwg3iuyHCkuIi+xn5qXIsuRQoT0fmo+qBwpyoctREif4OSnKB92aiFp0wbwCU5+CmoLmUrIYYKzAJ6pYAxXpi1HpotI76cWxrRtIbmF9H5qsUzbFpJbSO+nFs80bSG5hPR+qjLCzuPZFuRgYiG9n6oW8mHzlCMTC1nB6uXqT9VNzraQiYSkaKSWBfAoJU9byGQR6f1UbUzqw2YW0vupepl0eV5mIX2Cox/GWGYfNpOQ3k8tjcxtIalCxgkOoE9wSiJrW0h6RMoER8VBKZ6MZGwLuVBI76caQoa2EHbxi95PNYW0XZvPFdJWP5UJ5uZtIGXX5kQhbfZTueinColCWCn2RW0hiULa7KciY6n3dJmF27NT8ygX+LBntjBzff9U1VuY6YBDb/70iUBnIpJhsR3QZSATg5dJ9la8EqoP1idwSW0hYxEZ+6nAtG0pooFICLGFKLpS3iY45E6dHnXGtvl00E+lVdOhRcdkZmY4O7J59Px4aO38HhecIXis4HSz1sk9suL7U21jdM4yHnM+rtVqB/vVj+Cxi5Htt+OIPPi/0gSPfdD221euNOlhLKRA1gSPlQjRb9KVDX4TP4HHSqSTFZ+cMEx2LLWsPHSfDOmCLic6MpPryknxv4dPnR11+JfePPv02c3aUQr4/JN8gzeX9hr0i46QkNKugqMEFR7U1O8RqRdpyz28tfz+2eifDY+QaG0/me1Kt8d6P3mMq0HomIQ0HwmvT4s4Cr2GI9aWKzAIgggcQoBIPdODC3UHuJTCl8OIzczsl3Iolyrk7H/q+xGITr3nfZnUsWsPu13K7sARpEjOtnokIm26Y4tOEoEjMMS7aV8jkx1nWjw5wFu6suGT1POkbIGmd3YGSxwSGS5/cMYAweH5mAOvNUOCYBfY2mnX10db7an7bPdpfc21/fIQK5vxlX4jd6e3X33n6NKAaHgNwTXk/fHm8t41ehhHJCU8fQFupeQnhOBo5wMiHI+kJ4YAig3wWEUfxIujx8dCUkeWi46Hq5CDNdpFN2bRSYWdNZWdA0Vr9OmYkLHCiI5lsO4xOEd6vJP+jGnOBXvoktPjHhj1oXJm5DwjJE33CMEXwWMknIvVpFPdE6exbi5/eOXyJKytSDNjde7R3kbSaxf20u+0b7Rk1em3ZTGAWMSl3dZ5r6cuivBilk+aiESm1S1ezPJIaltJIvMyJVowMlhyJ0LwaAAjDnzxvAW7p8ncs0N/IQd2Ryr/HDxKoQ7Az18ObmcVkci1cLDTvhUy0W+B34OnUKjQpxoxqbzI8L35IUFRHN6TM+4L4HADsEqE9Ezl/9+mjMBn1LIBOSlsKe8gSnsN+YM1AVlDTrHUhMAaovgRPFIwHHS8I2wB70eCMTmz39s8valDXr4CH8ibA+WtvQMAAAAASUVORK5CYII=";
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      array: [],
      tituloModalHerramientas: '<span class="mt-4" style="font-weight:600; font-size: 20px">¿Estás seguro de que deseas descargar?</span></br>',
      parrafoHerramienta: '<span class="mt-5" style="font-weight:600; color: #e98918; font-size: 17px">Una vez que se descargue el archivo de cargo automático,no se podrá descargar nuevamente</span>',
      imagenModalBase64: null,
      loader: false,
      datosEntradaTxt:[],
      nombreArchivo: null
    };
  },
  methods: {
    archivo() {
      this.array = []
      let idIndentificadorBuzon = process.env.VUE_APP_IDENTIFICADOR_BUZON_MULTIVA;
      let idEmpresa = process.env.VUE_APP_IDEMPRESA_MUTIVA;
      let fecha = moment(new Date()).format("YYMMDDHHmm");
      let fechaContrato = moment(new Date()).format("YYMMDD");
      this.lst.forEach(element => {
        this.array.push(element.referencia,"\t", element.numeroTrajeta,"\t", element.importe,"\t", element.correoElectronico,"\t", element.contrato+fechaContrato)
        this.array.push("\n")
      });
      var arraySinComas = this.array.join("")

      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(arraySinComas));
      element.setAttribute('download', "pcv" + idEmpresa + idIndentificadorBuzon + fecha + "_token.txt");
      document.body.appendChild(element);
      element.click();
      this.$swal({
        icon: "success",
        text: "Se descargo el archivo exitosamente",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
      this.actualizarBandeja();
    },
    modalAlvertenciaDescagarTxt() {
      this.$swal.fire({
        width: '700px',
        html: '<div class="container-fluid cew-9"> ' +
            '<img alt="img" class="mt-3" src="' + this.imagenModalBase64 + '"></br>' +
            ' <div class="row justify-content-center">' +
            this.tituloModalHerramientas +
            this.parrafoHerramienta +
            ' </div>' +
            '</div>',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Si, continuar',
        confirmButtonColor: "#e98918",
        cancelButtonColor: "#595959",
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.actualizarEstatusReferencia();
        }
      });
    },
    actualizarEstatusReferencia() {
      let enviar = {
        idsMultivaArchivoSFTP: this.idsMultivaArchivoSFTP
      }
      this.loader = true;
      this.$http
          .post(this.$api + 'multiva/generar/actualizarEnvioSFTP', enviar)
          .then(respuesta => {
            if (respuesta.data.data) {
              if (respuesta.data.data !== undefined) {
                this.archivo();
              }
            }
          })
          .catch(error => {
            this.$swal.fire({
              icon: "error",
              title: "Ocurrió un problema",
              text: "Por favor espere unos minutos y vuelva a intentar",
            })
            console.error(error);
          }).finally(() => {
        this.loader = false;
      })
    },
    actualizarBandeja(){
      this.$emit("_actualizarBandeja");
    },
  },
}
</script>
